import { Box, BoxProps, makeStyles } from '@material-ui/core';
import React from 'react';

export type ContentProps = BoxProps & {

}

export function Content (props: ContentProps) {
    const cls = useStyles();

    return (
        <Box className={cls.root} {...props}>

        </Box>
    )
}

const useStyles = makeStyles(theme => ({
    root: {
        paddingRight: theme.spacing(3),
        paddingBottom: theme.spacing(3),
        paddingLeft: theme.spacing(3)
    }
}));